import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from 'environments/environment';
import { AppModule } from 'app/app.module';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';

// ── Portal magic-link forwarding ─────────────────────────────────────────────
// Firebase email-link sign-in routes the raw action link through the project's
// default domain (e.g. rd2-dev.web.app), carrying the sign-in params in the
// query string. For the external-user portal, sign-in must complete on the
// portal domain, because that is the origin where the requesting user's
// `emailForSignIn` was stored in localStorage (localStorage is origin-scoped).
//
// If we detect a magic link (`mode=signIn` + `oobCode`) that has landed on any
// origin other than the portal domain, forward it to the portal domain,
// preserving the query string byte-for-byte so the oobCode stays valid and
// `signInWithEmailLink()` can complete there.
(function forwardMagicLinkToPortal(): void {
  try {
    const params = new URLSearchParams(window.location.search);
    const isMagicLink = params.get('mode') === 'signIn' && !!params.get('oobCode');
    const portalDomain = environment.portalDomain;

    if (isMagicLink && portalDomain && window.location.hostname !== portalDomain) {
      window.location.replace(
        `https://${portalDomain}/sign-in-email-link${window.location.search}`
      );
    }
  } catch {
    // If anything goes wrong, fall through and let the app bootstrap normally.
  }
})();

if (environment.production) {
  enableProdMode();
}

ModuleRegistry.registerModules([AllCommunityModule]);

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
